<template>
   <div>
      <router-view name="header" />
      <div id="wrapper">
         <router-view></router-view>
         <!-- <router-view name="footer" /> -->
      </div>
   </div>
</template>
<script>

window.onscroll = ()=>{
   var element = document.scrollingElement
   if(element.scrollTop > 20){
      
   }else{
      
   }
}
</script>

<style>
@font-face {
  font-family: "custom-font";
  src: url(./assets/webfonts/EkkamaiNew-Regular.ttf)
}
</style>
<style>
   @import'~bootstrap/dist/css/bootstrap.css'
</style>
<style src="@/assets/css/main.css">
</style>



// WEBPACK FOOTER //
// src/App.vue